import Scene from "./Scene";
import common from "../common";
import {translate} from "../utils";
import Drawing from "../drawing/Drawing";
import World from "../game/World";

export default class GameScene extends Scene {

    constructor() {
        super();

        this._paths = [];

    }

    init() {
        super.init();

        // this sets paperjs up
        this._drawing = new Drawing();
        this._drawing.init();

        // create the world
        this._world = new World(P3.assets.json(P3.utils.selectRandom([
            "bezier_01",
            "bezier_02",
            "bezier_03",
            "bezier_04",
            "bezier_05"
        ])));
        this.addChild(this._world);

        // we only needed the drawing for the paperjs canvas, so we can destroy after creating world
        this._drawing.destroy();

        this._world.signals.completed.once(this.end, this);

    }

    destroy() {
        super.destroy();
    }

    resize() {
        super.resize();
    }

    animateIn() {
        P3.utils.delayg(this._tweens, 2, () => {
            this._world.begin();
        });
    }

    update(dt = window.deltaTime) {
        super.update();

        this._world.update(dt);
    }

    end() {
        this.signals.next.dispatch();
    }
}

